import { createAsyncThunk, isPending } from '@reduxjs/toolkit';
import { apiOkr } from 'app/config/axios-interceptor';
import { EntityState, createEntitySlice, serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState: EntityState<any> = {
  loading: false,
  errorMessage: null,
  entities: null,
  entity: {},
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/okr/checkIn';

export const getListKrCheckInYear = createAsyncThunk(
  'checkInYear/fetch_list_Kr_year',
  async ({ krId, reportScheduleId }: any, { rejectWithValue }) => {
    try {
      const response = await apiOkr.get<any>(`${apiUrl}/next-checkin-item`, {
        params: {
          krId,
          reportScheduleId,
        },
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  { serializeError: serializeAxiosError },
);

export const getKrQualCheckInYear = createAsyncThunk(
  'checkInYear/fetch_KrQual_year',
  async ({ krId, reportScheduleId }: any, { rejectWithValue }) => {
    try {
      const response = await apiOkr.get<any>(`${apiUrl}/checkin-year-qual`, {
        params: {
          krId,
          reportScheduleId,
        },
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  { serializeError: serializeAxiosError },
);

export const getKrQuantCheckInYear = createAsyncThunk(
  'checkInYear/fetch_KrQuant_year',
  async ({ krId, reportScheduleId }: any, { rejectWithValue }) => {
    try {
      const response = await apiOkr.get<any>(`${apiUrl}/checkin-year-quan`, {
        params: {
          krId,
          reportScheduleId,
        },
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  { serializeError: serializeAxiosError },
);

export const checkIntKrQualYear = createAsyncThunk(
  'checkInYear/create_checkin_KrQual_year',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await apiOkr.post<any>(`${apiUrl}/checkin-year-qual`, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  { serializeError: serializeAxiosError },
);

export const checkIntKrQuantYear = createAsyncThunk(
  'checkInYear/create_checkin_KrQuant_year',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await apiOkr.post<any>(`${apiUrl}/checkin-year-quan`, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  { serializeError: serializeAxiosError },
);
// slice

export const CheckInYearSlice = createEntitySlice({
  name: 'checkInYear',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getListKrCheckInYear.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = action.payload.data;
      })
      .addCase(getKrQualCheckInYear.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addCase(getKrQuantCheckInYear.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addCase(checkIntKrQualYear.fulfilled, (state, action) => {
        state.updating = false;
        state.updateSuccess = true;
      })
      .addCase(checkIntKrQuantYear.fulfilled, (state, action) => {
        state.updating = false;
        state.updateSuccess = true;
      })
      .addMatcher(isPending(getListKrCheckInYear), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.entities = [];
      })
      .addMatcher(isPending(checkIntKrQualYear, checkIntKrQuantYear), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      })
      .addMatcher(isPending(getKrQualCheckInYear, getKrQuantCheckInYear), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
        state.entity = {};
      });
  },
});

export const { reset } = CheckInYearSlice.actions;

// Reducer
export default CheckInYearSlice.reducer;
